export const UPLOAD = 'upload/UPLOAD';
export const UPLOAD_FAILURE = 'upload/UPLOAD_FAILURE';
export const UPLOAD_SUCCESS = 'upload/UPLOAD_SUCCESS';
